<app-header
        [navItems]="navItems"
>
  <div subtitle>
    {{ 'meteringpoint.title' | translate }}
  </div>
    @if (meteringPoint) {
        <div title>{{ address || '-' }}</div>
    }
</app-header>

<div class="pane-wrapper">
    <router-outlet></router-outlet>
</div>
